import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './style.scss';


class TextTruncate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
      contentHeight: 0,
      maxHeight: this.props.linescount * 24, // multiple by default font-size & line-height
    };
  }

  toggleHeight() {
    this.setState(({ isExpanded }) => {
      return { isExpanded: !isExpanded };
    });
  }

  componentDidMount() {
    this.setState({
      contentHeight: this.textElement.clientHeight,
    });

    if (this.textElement.clientHeight < this.state.maxHeight) {
      this.setState({
        isExpanded: true,
      });
    }
  }

  render() {
    const { children, expandLabel, collapseLabel, theme, textColor } = this.props;
    const { isExpanded, contentHeight, maxHeight } = this.state;
    const textStyle = {
      color: textColor && `#${textColor}`,
    };

    return (
      <div className={styles.content}>
        <div style={{ height: !isExpanded && `${maxHeight}px` }} className={styles.wrap}>
          <div
            style={textStyle}
            className={styles.text}
            ref={(node) => { this.textElement = node; }}>
            {children}
          </div>
        </div>
        {maxHeight < contentHeight && (
          <React.Fragment>
            <span
              className={classNames(styles.expandLabel, { isHidden: isExpanded }, theme && styles[`${theme}Theme`])}
              onClick={() => this.toggleHeight()}>
              {expandLabel}
            </span>
            {collapseLabel && isExpanded && (
              <span
                className={classNames(styles.collapseLabel, { isHidden: !isExpanded })}
                onClick={() => this.toggleHeight()}>
                {collapseLabel}
              </span>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

TextTruncate.propTypes = {
  linescount: PropTypes.string,
  expandLabel: PropTypes.string,
  collapseLabel: PropTypes.string,
  textColor: PropTypes.string,
  children: PropTypes.node.isRequired,
};

TextTruncate.defaultProps = {
  linescount: '10',
  expandLabel: 'Показать полностью',
  collapseLabel: '',
};

export default TextTruncate;
